module.exports = __webpack_public_path__ + "static/media/irregularTriangle3.e09e99cc.svg";